import axios from 'axios'
import store from '../store'
import { notificationActions, accountActions } from '../actions'

const url =
    process.env.NODE_ENV === "development"
        ? process.env.REACT_APP_DEV_API_URL
        : process.env.REACT_APP_PROD_API_URL

const backend = axios.create({ baseURL: url })

backend.interceptors.response.use(
    res => res,
    err => {
        if (!err.response) {
            store.dispatch(notificationActions.showError(
                { message: "Error de conexión al servidor" }))

            return Promise.reject({ ...err, intercepted: true })
        }

        switch (err.response.status) {
            case 401:
                store.dispatch(notificationActions.showError(
                    { message: "La sesión actual ya no es válida" }))
                store.dispatch(accountActions.invalidToken())

                return Promise.reject(
                    { ...err, intercepted: true, })
            case 500:
                store.dispatch(notificationActions.showError(
                    { message: "Error interno del servidor" }))

                return Promise.reject(
                    { ...err, intercepted: true })
            default:
                return Promise.reject(err)
        }
    }
)

export default backend

